import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import llovizna from "./assets/Llovizna.svg";
import lluviaLigera from "./assets/Lluvia_ligera.svg";
import lluviaLigeraAModerada from "./assets/Lluvia_ligera_a_moderada.svg";
import lluviaModerada from "./assets/Lluvia_moderada.svg";
import lluviaModeradaAFuerte from "./assets/Lluvia_moderada_a_fuerte.svg";
import lluviaTorrencial from "./assets/Lluvia_torrencial.svg";
import lluviaFuerteATorrencial from "./assets/Luvia_fuerte_a_torrencial.svg";
import tiempoSeco from "./assets/Tiempo_Seco.svg";
import ImageComponent from "./ImageComponent";
import luna from "./assets/luna.png";

const useTooltipStyles = makeStyles({
  tooltip: {
    position: "relative",
    display: "inline-block",
    "&:hover $tooltipText": {
      visibility: "visible",
      opacity: 1,
    },
  },
  tooltipText: {
    visibility: "hidden",
    width: "120px",
    backgroundColor: "#fff",
    color: "#000",
    textAlign: "center",
    borderRadius: "6px",
    padding: "5px 0",
    position: "absolute",
    zIndex: 1,
    top: "85%",
    left: "50%",
    marginLeft: "-60px",
    opacity: 0,
    transition: "opacity 0.3s",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "100%",
      left: "50%",
      marginLeft: "-5px",
      borderWidth: "5px",
      borderStyle: "solid",
      borderColor: "transparent transparent white transparent",
    },
  },
});

const rainMapping = {
  tiemposecosol: { image: tiempoSeco, text: "Tiempo seco" },
  tiemposecoluna: { image: luna, text: "Tiempo seco" },
  llovizna: { image: llovizna, text: "Llovizna" },
  lluvialigera: { image: lluviaLigera, text: "Lluvia ligera" },
  lluvialigeraamoderada: {  image: lluviaLigeraAModerada, text: "Lluvia ligera a moderada" },
  lluviamoderada: { image: lluviaModerada, text: "Lluvia moderada" },
  lluviamoderadaafuerte: { image: lluviaModeradaAFuerte, text: "Lluvia moderada a fuerte" },
  lluviafuerteatorrencial: { image: lluviaFuerteATorrencial, text: "Lluvia fuerte a torrencial" },
  lluviatorrencial: {  image: lluviaTorrencial, text: "Lluvia Torrencial" },
};

const GetRainIcon = ({ lluvia }) => {
   
    const classes = useTooltipStyles();
    const iconData = rainMapping[lluvia] || { image: tiempoSeco, text: "sin información" };
  
    return (
      <div className={classes.tooltip}>
        <ImageComponent src={iconData.image} />
        <span className={classes.tooltipText}>{iconData.text}</span>
      </div>
    );
  };
  

GetRainIcon.propTypes = {
  lluvia: PropTypes.number.isRequired,
};

export default GetRainIcon;
